import { APP_COUNTRY } from 'config';

function isCountryWithBanner(): boolean {
  const countriesWithBanner = ['fr'];
  return countriesWithBanner.includes(APP_COUNTRY);
}

export default isCountryWithBanner;
